import {
  Suffix,
  translateChoice,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

interface ChoiceSummaryDecoratorProps {
  fallbackValue?: string;
  fieldId: string;
}

const ChoiceSummaryDecorator = ({
  fieldId,
  fallbackValue,
}: ChoiceSummaryDecoratorProps) => {
  const { findFieldById, translatorFor } = useFormDataContext();

  const field = findFieldById(fieldId);
  const translator = translatorFor(field);
  const value = field.value.asChoice();

  const label = translateField(translator, field, Suffix.LABEL);

  return (
    <>
      <span>{label.toString()}</span>
      <pre>
        {value.hasBeenSet()
          ? `${translateChoice(translator, field, value.mustSelection(), Suffix.LABEL)}`
          : (fallbackValue ?? translator.translate("noSelection"))}
      </pre>
    </>
  );
};

export default ChoiceSummaryDecorator;
